import React from "react";

import * as S from "./styles";
import { IProps } from "./types";
import { useParams } from "react-router";
import { useQuery } from "@apollo/react-hooks";
import { FLASH_CAMPAIGN } from "@components/pages/FlashSalePage/queries";
import { flashCampaign } from "@components/pages/FlashSalePage/__generated__/flashCampaign";
import { Loading } from "@atoms";
import { getGraphqlIdFromDBId } from "@utils";
import { Container } from "react-bootstrap";
import { useAlert } from "react-alert";

const FlashSalePage: React.FC<IProps> = ({
  // destructure props here if needed
}: IProps) => {
  //@ts-ignore
  const {flashSaleId} = useParams();
  const id = getGraphqlIdFromDBId(flashSaleId, "FlashSaleCampaign");

  const alert = useAlert();
  const {data, loading, error} = useQuery<flashCampaign>(FLASH_CAMPAIGN, {
    variables: {id},
  });

  return data && (
    <Container>
      <S.Wrapper
        dangerouslySetInnerHTML={{__html: data?.flashCampaign?.campaignContent}}
      />
    </Container>
  ) || <Loading/>;
};

export { FlashSalePage }